import React from "react";
export const PageHeading: React.FC<any> = ({ heading, subText, rightContent }) => {
  return (
    <div className="sm:flex sm:items-center">
      <div className="flex flex-row flex-wrap gap-2 items-center">
        <h1 className="text-base font-semibold leading-6 text-gray-900 dark:text-white">
          {heading}
        </h1>
        <p className="text-sm text-gray-700 dark:text-gray-200">{subText}</p>
      </div>
      <div className="mt-1 sm:mt-0 sm:ml-auto sm:flex sm:flex-shrink-0 sm:items-center">
        {rightContent}
      </div>
    </div>
  );
};
